import React, {
    memo,
    Fragment,
    useState,
    useContext,
    useEffect,
    useRef,
} from "react";

import { AuthContext } from "../../common/middlewares/Auth";

import {
    Grid,
    Card,
    CardActionArea,
    CardHeader,
    CardMedia,
    CardContent,
    Typography,
    CircularProgress,
    useTheme,
    useMediaQuery,
    Box,
} from "@mui/material";

import { createStyles } from "@mui/material/styles";
import Player from "react-lottie-player";
import { toast } from 'react-hot-toast';

//Librerias
import { useNavigate } from "react-router-dom";

//Componentes
import Trofeo from "./Components/Trofeos";
import CarnetDigital from "./Components/CarnetDigital";
import useGetPasivoVacacional from "./Hooks/useGetPasivoVacacional";

const homeStyle = createStyles((theme) => ({
    imgHome: {
        width: "950px",
        height: "700px",
        [theme.breakpoints.down("sm")]: {
            width: "700px",
            height: "550px",
        },
    },
    imgHomeMovil: {
        width: "350px",
        height: "450px",
    },
    container: {
        position: "relative",
        display: "flex",
        height: "80vh",
        paddingTop: "24px",
    },
}));

const Home = () => {
    //===============================================================================================================================================
    //========================================== Hooks personalizados ===============================================================================
    //===============================================================================================================================================
    const history = useNavigate();
    const theme = useTheme();
    const movil = useMediaQuery(theme.breakpoints.down("sm"));
    const large = useMediaQuery(theme.breakpoints.down("md"));

    const { getUniqueData } = useGetPasivoVacacional()
    const refGetUniqueDataVacaciones = useRef(getUniqueData)
    //===============================================================================================================================================
    //==================================================== Context ==================================================================================
    //===============================================================================================================================================
    const authContext = useContext(AuthContext);
    const { strInfoUser } = authContext;

    //===============================================================================================================================================
    //==================================================== States ===================================================================================
    //===============================================================================================================================================

    const [data, setData] = useState();
    const [load, setLoad] = useState(false);

    //===============================================================================================================================================
    //==================================================== Funciones ================================================================================
    //===============================================================================================================================================

    //===============================================================================================================================================
    //==================================================== useEffects ===============================================================================
    //===============================================================================================================================================
    useEffect(() => {
        if (strInfoUser?.strEmail) {
            async function getDataFlujo() {
                setLoad(true)
                await refGetUniqueDataVacaciones
                    .current({
                        strEmailColaborador: strInfoUser?.strEmail
                    })
                    .then((res) => {
                        if (res.data.error) {
                            toast.error(res.data.msg);
                        }
                        setData(res?.data?.data)
                        setLoad(false)
                    })
                    .catch((error) => {
                        toast.error(error?.message || "Error al cargar datos de vacaciones.");
                        console.error(error)
                        setLoad(false)
                    })
            }
            getDataFlujo()
        }
    }, [strInfoUser]);

    //===============================================================================================================================================
    //==================================================== Renders ==================================================================================
    //===============================================================================================================================================
    const classes = homeStyle(theme);

    return (
        <Fragment>
            <Grid
                container
                direction="row"
                alignItems="center"
                style={classes.container}
            >
                <Grid item xs={12}>
                    <Grid
                        container
                        direction="row"
                        alignItems="stretch"
                        justifyContent="center"
                        spacing={2}
                    >

                        <CarnetDigital />

                        <Grid item xs={12} sm={3}>
                            <Card style={{ height: "100%", display: "flex" }}>
                                <CardActionArea
                                    onClick={() => {
                                        history("/wilson/perfil");
                                    }}
                                >
                                    <CardHeader
                                        title={<b>Información personal</b>}
                                        titleTypographyProps={{
                                            variant: "subtitle1",
                                            gutterBottom: true,
                                            align: "center",
                                            component: "h5",
                                        }}
                                    />
                                    <CardMedia style={{ display: "flex", justifyItems: "center", justifyContent: "center" }}>
                                        <Player
                                            play
                                            loop
                                            animationData={require("../../static/json/Document.json")}
                                            style={movil ? { width: "150px" } : { width: "300px" }}
                                        />
                                    </CardMedia>
                                    <CardContent>
                                        <br />
                                        <Typography
                                            variant="body2"
                                            component="p"
                                            align={large ? "center" : "inherit"}
                                        >
                                            Consulta y actualiza tu información personal
                                        </Typography>
                                        <br />
                                        <br />
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            {load ? (
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    style={{
                                        paddingTop: 170,
                                    }}
                                >
                                    <CircularProgress color="primary" size={45} />
                                </Box>
                            ) : (
                                <Card style={{ height: "100%", display: "flex" }}>
                                    <CardActionArea href="https://novedades.choucairtesting.com/novedades/">
                                        <CardHeader
                                            title={<b>Vacaciones</b>}
                                            titleTypographyProps={{
                                                variant: "subtitle1",
                                                gutterBottom: true,
                                                align: "center",
                                                component: "h5",
                                            }}
                                        />
                                        <CardMedia style={{ display: "flex", justifyItems: "center", justifyContent: "center" }}>
                                            <Player
                                                play
                                                loop
                                                animationData={require("../../static/json/2523-loading.json")}
                                                style={movil ? { width: "150px" } : { width: "280px" }}
                                            />
                                        </CardMedia>
                                        <CardContent>
                                            <Typography
                                                variant="body2"
                                                component="p"
                                                align={large ? "center" : "inherit"}
                                            >
                                                Usted dispone de{" "}
                                                {
                                                    <b style={{ fontSize: "20px" }}>
                                                        {data?.Dias}
                                                    </b>
                                                }{" "}
                                                días de pasivo vacacional. {data?.strFechaCorte} Dale
                                                clic aqui para gestionar tus solicitudes de vacaciones
                                            </Typography>
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            )}
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <Trofeo />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Fragment>
    );
};

export default memo(Home);
